import { render, staticRenderFns } from "./WxJump.vue?vue&type=template&id=587a2f07&scoped=true&"
import script from "./WxJump.vue?vue&type=script&lang=js&"
export * from "./WxJump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a2f07",
  null
  
)

export default component.exports